import request from "./request";
import apis from "./apis";

const {
  announcementInfo,
  allClassroomInfo,
  calendarInfo,
  importCalendarFile,
  classroomCountingPeople,
  exportCalendar,
} = apis.announcement;

const announcement = {
  getAnnouncementInfo: (data: Object) => {
    return request.get(announcementInfo, data);
  },
  getAllClassroomInfo: () => {
    return request.get(allClassroomInfo);
  },
  getCalendarInfo: (data: Object) => {
    return request.get(calendarInfo, data);
  },
  createCalendarInfo: (data: Object) => {
    return request.post(calendarInfo, data);
  },
  updateCalendarInfo: (data: Object) => {
    return request.put(calendarInfo, data);
  },
  deleteCalendarInfo: (data: Object) => {
    return request.dataDelete(calendarInfo, data);
  },
  exportCalendar: (data: Object) => {
    return request.get(exportCalendar, data);
  },
  importCalendarFile: (data: Object) => {
    return request.formJsonPost(importCalendarFile, data);
  },
  getClassroomCountingPeople: (data: Object) => {
    return request.get(classroomCountingPeople, data);
  },
};

export default announcement;